import styled from 'styled-components';

import { OnboardingTitle } from '../../../../../Onboarding/components/Title';
import { LimitedTimer } from '../../../V1/components/LimitedTimer';

export const SectionImagesStyles = styled.section`
  body.dark & {
    background: url(https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/paywall/bg-line-dark.png);
    background-repeat: no-repeat;
    background-size: 110% 100%;
    background-position: 0 0;
  }

  padding: 48px 0 0;
  margin: 0 0 16px;
  background: url(https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/paywall/bg-line.png),
    url(https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/paywall/bg-mobile.png);
  background-repeat: no-repeat, no-repeat;
  background-size:
    110% 100%,
    100% 100%;
  background-position:
    0 0,
    0 0;

  @media screen and (min-width: 768px) {
    background: url(https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/paywall/bg-line.png),
      url(https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/paywall/bg-desktop.png);
    background-repeat: no-repeat, no-repeat;
    background-size:
      110% 100%,
      100% 100%;
    background-position:
      0 0,
      0 0;
  }

  .images-subtitle {
    padding: 0 10px;
    margin: 0 auto;
    max-width: 540px;
    text-align: center;
  }
`;

export const SectionImagesImageContainerStyles = styled(OnboardingTitle)`
  max-width: 320px;
  height: 550px;
  width: 100%;
  margin: 40px auto 0;
  position: relative;

  @media screen and (min-width: 768px) {
    max-width: 540px;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const SectionImagesTitleStyles = styled(OnboardingTitle)`
  max-width: 220px;
  padding: 0 10px;

  @media screen and (min-width: 768px) {
    max-width: 540px;
  }
`;

export const SectionImagesArrowDownStyles = styled.div`
  position: absolute;
  left: 50%;
  top: 350px;
  transform: translateX(-50%);
  z-index: 3;
  background-color: #fff;
  font-size: 34px;
  width: 32px;
  height: 64px;
  padding: 0;
  border: 1px solid #dbc9ff;
  border-radius: 16px;
  box-shadow: 0px 9px 14px 0px #b28aff66;

  animation-duration: 1s;
  animation-name: topbottom;
  animation-iteration-count: infinite;

  @keyframes topbottom {
    0% {
      transform: translate(-50%, 0px);
    }

    50% {
      transform: translate(-50%, 5px);
    }

    100% {
      transform: translate(-50%, 0px);
    }
  }

  img {
    position: absolute;
    width: 16px;
    height: 32px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const SectionImagesTimerStyles = styled(LimitedTimer)`
  position: absolute;
  bottom: 0;
  z-index: 3;
  max-width: 300px;
  left: 50%;
  transform: translateX(-50%);

  @media screen and (min-width: 576px) {
    max-width: 400px;
  }
`;
